import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { InputsIcon } from '../Icons/Editor Panels';

interface ControllerFirmwareUpdateMessageProps {
  message: string;
}

const ControllerFirmwareUpdateMessage = ({ message }: ControllerFirmwareUpdateMessageProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Box
      sx={{
        color: 'inherit',
        display: 'inline-flex',
        flexShrink: 0,
        height: 24,
        width: 24,
        '& svg': {
          display: 'block',
        },
      }}
    >
      <InputsIcon aria-hidden focusable="false" width={24} height={24} />
    </Box>
    <Typography component="span" variant="body2">
      {message}
    </Typography>
  </Box>
);

export default ControllerFirmwareUpdateMessage;
